import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterLinkActive} from '@angular/router';
import {Subscription} from 'rxjs';
import {UserContextService} from '../../../../core/services/user-context.service';
import {MyHttpClient} from '../../../../shared/services/my-http-client.service';
import {ITrackingService} from '../../services/tracking.service.interface';
import {ServicesApprovalService} from '../../../service/services/services-approval.service';
import FormUtils from '../../../../shared/utils/formUtils';
import {TrackingCalledSectionMenuEnum} from '../../enums/tracking-called-section-menu.enum';
import {TrackingCalledSectionDashboardEnum} from '../../enums/tracking-called-section-dashboard.enum';
import {environment} from 'src/environments/environment';
import {SecFEPermissionPartnerAppEnum} from 'src/app/shared/enums/sec-f-e-permission-partner-app-enum';
import {ModalDynamicV3Service} from '../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {ProjectsBodyScrollingService} from '../../../projects/services/projects-body-scrolling.service';
import {ToastService} from '../../../../shared/services/toast.service';
import {UserDetailsModel} from '../../../auth/models/user-details-model';
import {
    ModalDataProcessingAgreementNotConfirmedInfoComponent
} from '../../../data-processing-agreement/components/modal-data-procesing-agreement-not-confirmed-info/modal-data-procesing-agreement-not-confirmed-info.component';

@Component({
    selector: 'app-main-header',
    templateUrl: './main-header.component.html',
    styleUrl: './main-header.component.scss'
})
export class MainHeaderComponent implements OnInit, OnDestroy {

    // public readonly CADOOZ_LOGIN_URL = 'https://brother.cadooz.com/cips/login.do';

    private routerSubscription: Subscription;

    protected readonly environment = environment as any;

    public title = '';
    public menuStatus = false;
    // public jSessionId: string = 'HGjnsDRIo8LVBG7ysHXTXgOpVNNu_tOtLwgqN6xl.w03';
    public initialized: boolean;


    // public isCspReadOnly = false;
    // public cspAllowed: boolean;
    // public cspConnectedAllowed: boolean;
    // public ppbAllowed: boolean;
    // public projectManagementAllowed: boolean;

    public TrackingCalledSectionMenuEnum = TrackingCalledSectionMenuEnum;
    public TrackingCalledSectionDashboardEnum = TrackingCalledSectionDashboardEnum;
    // public gAuthData = {} as GroupAuthorizationDataModel;

    protected readonly SecFEPermissionPartnerAppEnum = SecFEPermissionPartnerAppEnum;
    headerStyles: { color?: string, backgroundColor?: string, logoFilter?: string } = environment['headerStyles'];


    constructor(
        private router: Router,
        private httpClient: MyHttpClient,
        private trackingService: ITrackingService,
        private servicesApprovalService: ServicesApprovalService,
        public userContextService: UserContextService,
        private modalDynamicV3Service: ModalDynamicV3Service,
        private projectsBodyScrollingService: ProjectsBodyScrollingService,
        private toastService: ToastService,
    ) {
        this.routerSubscription = router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                const title = this.getTitle(router.routerState, router.routerState.root);
                this.title = title[0];
            }
        });
    }

    async ngOnInit() {
        // load user-details, cadooz poits, etc. ...
        try {
            await this.userContextService.reloadUserDetails();
        } catch (e) {
        }
        // this.gAuthData = this.authorizationService.getAuthorizationData();
    }

    ngOnDestroy() {
        console.log('MasterDetailRootComponent destroy');
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    getTitle(state, parent) {
        const data = [];
        if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            data.push(parent.snapshot.data.title);
        }

        if (state && parent) {
            data.push(...this.getTitle(state, state.firstChild(parent)));
        }
        return data;
    }

    toggleMenuEvent() {
        this.menuStatus = !this.menuStatus;

        if (this.menuStatus) {
            this.projectsBodyScrollingService.disableBodyScrolling();
        } else {
            this.projectsBodyScrollingService.enableBodyScrolling();
        }
    }

    collapse(event) {
        const target = event.currentTarget;
        target.classList.toggle('dropdown-show');
    }

    getUserEmail(): string {
        const userDetails: UserDetailsModel = this.userContextService.getUserDetails();
        return userDetails?.email;
    }

    // getCadoozPoints(): number {
    //     const cadoozPoints: number = this.userContext.getCadoozPoints();
    //     // console.log('Cadooz Poits:', cadoozPoints);
    //     return cadoozPoints;
    // }

    async openDealerPortalProtectedLink(url: string): Promise<void> {
        const dealerPortalSecurityToken: string = this.userContextService.getDealerPortalSecurityToken();
        if (!dealerPortalSecurityToken) {
            this.toastService.showError('Page cannot be opened, the Dealer Portal Security Token is missing');
            console.error('Dealer Portal Security Token is missing');
            return;
        }
        await FormUtils.openDealerPortalProtectedLink(this.httpClient, url, dealerPortalSecurityToken);
    }

    async onMineMenuTogglerClicked(menuItemId: TrackingCalledSectionDashboardEnum) {
        this.toggleMenuEvent();
        const menuId = TrackingCalledSectionDashboardEnum[menuItemId];
        // console.log(menuId);
        try {
            await this.trackingService.createTrackingEvent(menuId, new Date());
        } catch (e) {
            console.error(e);
        }

    }


    async onMenuItemClicked(menuItemId?: TrackingCalledSectionMenuEnum, secureLink?: HTMLAnchorElement) {

        if (menuItemId === TrackingCalledSectionMenuEnum.MENU_SERVICE) {

            console.log('MENU_SERVICE');

            if (await this.servicesApprovalService.areServicesApproved()) {  // it also shows Approval modal if not approved to allow user to approve if needed
                secureLink.href = 'https://service.brother.co.jp/training/all/index.html?area=eu';
                secureLink.click();
                setTimeout(() => {
                    secureLink.href = '';
                }, 100);
            } else {
                console.log('Some documents are not approved yet');
                this.servicesApprovalService.showModalAgreementNotConfirmedInfo();
            }
        }


        this.toggleMenuEvent();
        const menuId = TrackingCalledSectionMenuEnum[menuItemId];
        // console.log('   >>> ', menuId);
        if (menuId) {
            try {
                await this.trackingService.createTrackingEvent(menuId, new Date());

            } catch (e) {
                console.error('response error', e);
            }

        } else {
            console.warn('unknown tracking id', menuItemId);
        }
    }

    async onMenuCollapseClicked(event, menuItemId?: TrackingCalledSectionMenuEnum) {
        this.collapse(event);
        const menuId = TrackingCalledSectionMenuEnum[menuItemId];
        // console.log('  [v]', menuId);
        if (menuId) {
            try {
                await this.trackingService.createTrackingEvent(menuId, new Date());
            } catch (e) {
                console.error('response error', e);
            }
        } else {
            console.warn('unknown tracking id', menuItemId);
        }
    }


    async runTestAction() {
        if (environment.version.includes('def') || environment.version.includes('dev')) {
            console.log('runTestAction');
            // this.modalDynamicV3Service.open(ModalServicesDataProcessingAgreementNewComponent);
            // await this.modalDynamicV3Service.openAsPromise(ModalAgreementNotConfirmedInfoComponent);
            await this.modalDynamicV3Service.openAsPromise(ModalDataProcessingAgreementNotConfirmedInfoComponent);
        }


    }


}
